import { useEffect, useState } from 'react';
import { buildFeatureFlagsStructure, type FeatureFlag, type ToggleFlag } from '../../test/utils/utilsFeatureFlags';
import { trace } from '../configuration/setup/trace';
import { useGetFeatureTogglesQuery } from '../store/facade/facadeApiV2';

const FEATURE_TOGGLES_POLLING_FREQ = 60; // in seconds

export const useFeatureToggles = () => {
    const { data: toggleData, isError } = useGetFeatureTogglesQuery(undefined, {
        pollingInterval: FEATURE_TOGGLES_POLLING_FREQ * 1000,
    });
    const [featureFlags, setFeatureFlags] = useState<FeatureFlag[]>([]);

    useEffect(() => {
        if (toggleData) {
            setFeatureFlags(buildFeatureFlagsStructure(toggleData as ToggleFlag));
        }
        if (isError) {
            trace.error('Was not able to fetch the account feature toggles');
        }
    }, [toggleData, isError]);

    return { featureFlags };
};
